import type React from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/petitionEditV2/pageContext';

export const PetitionEditErrorHandler: React.FC<ErrorHandlerProps> = ({ context: { error } }) => {
	throw new Error(`Failed to retrieve data for PetitionEdit page (error: ${error})`);
};
